import React from 'react';
import {
  TextField,
  Switch,
  FormControlLabel,
} from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { setData } from '../../redux';
import {  sortByDate } from '../../../helperFunctions/index';

export default () => {
  const data = useSelector(state => state.tasks.data);
  const dispatch = useDispatch();
  const startedTaskId = useSelector(state => state.tasks.taskStarted.taskId);
  const task = data.tasks.find(x => x.id === startedTaskId);
 
  if (!task) return null;

  const taskIndex = data.tasks.indexOf(data.tasks.find(x => x.id === task.id));
  const { documentsDashboard} = task;

  const handlePhoneChange = event => {
    const updatedClientInformation = { ...documentsDashboard.clientInformation };
    updatedClientInformation['phone'] = event.target.value;

    const updatedTasks = [...data.tasks];
    updatedTasks.splice(taskIndex, 1, {
      ...task,
      documentsDashboard: { ...documentsDashboard, clientInformation: updatedClientInformation },
    });

    dispatch(
      setData({
        ...data,
        tasks: updatedTasks.sort((a, b) => sortByDate(a, b)),
      })
    );
  };

  const handleIsPhoneCommunicationChange = event => {
    const updatedClientInformation = { ...documentsDashboard.clientInformation };
    updatedClientInformation.isPhoneCommunication = !updatedClientInformation.isPhoneCommunication;

    const updatedTasks = [...data.tasks];
    updatedTasks.splice(taskIndex, 1, {
      ...task,
      documentsDashboard: { ...documentsDashboard, clientInformation: updatedClientInformation },
    });

    dispatch(
      setData({
        ...data,
        tasks: updatedTasks.sort((a, b) => sortByDate(a, b)),
      })
    );
  };

  return (
    <div>
      <FormControlLabel
        control={
          <Switch
            color="primary"
            checked={documentsDashboard.clientInformation.isPhoneCommunication}
            onChange={handleIsPhoneCommunicationChange}
          />
        }
        label="Изпращане чрез SMS"
        labelPlacement="top"
      />
      {documentsDashboard.clientInformation.isPhoneCommunication && (
        <TextField
          label="Телефон"
          style={{ margin: '4px', marginBottom: '10px' }}
          value={documentsDashboard.clientInformation.phone ?? ''}
          fullWidth
          variant="filled"
          onChange={handlePhoneChange}
        />
      )}
    </div>
  );
};
